import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { API } from '../api';
import Layout from '../components/Layout';

const API_BASE = import.meta.env.VITE_API_BASE || "http://192.168.0.57:5000";

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes blink{0%,100%{opacity:1}50%{opacity:.3}}
  @keyframes blink-fast{0%,100%{opacity:1}50%{opacity:.2}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(16,185,129,0.4)}50%{box-shadow:0 0 0 8px rgba(16,185,129,0)}}
  *{box-sizing:border-box}
  .cd-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}
  .cd-input{width:100%;padding:11px 14px;background:#f0fdf4;border:1.5px solid #bbf7d0;
    border-radius:11px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .cd-input:focus{border-color:#10b981;background:#fff;box-shadow:0 0 0 3px rgba(16,185,129,0.15)}
  .cd-input::placeholder{color:#a0aec0}
  .cd-input[type=date]{cursor:pointer}
  .cd-input[type=number]{text-align:center}
  .cd-select{width:100%;padding:11px 14px;background:#f0fdf4;border:1.5px solid #bbf7d0;
    border-radius:11px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;cursor:pointer;appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2310b981' stroke-width='2' fill='none'/%3E%3C/svg%3E");
    background-repeat:no-repeat;background-position:right 14px center;
    transition:border-color 0.2s,box-shadow 0.2s}
  .cd-select:focus{border-color:#10b981;box-shadow:0 0 0 3px rgba(16,185,129,0.15)}
  .cd-select:disabled{background:#f0f0f0;color:#a0aec0;cursor:not-allowed}
  .cd-btn-primary{padding:12px 26px;background:linear-gradient(135deg,#34d399,#10b981);
    border:none;border-radius:11px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px;animation:pulse 2.5s ease-in-out infinite}
  .cd-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(16,185,129,0.4);animation:none}
  .cd-btn-primary:disabled{opacity:0.6;cursor:not-allowed;animation:none;transform:none}
  .cd-btn-secondary{padding:11px 22px;background:#f0fdf4;border:1.5px solid #bbf7d0;
    border-radius:11px;color:#065f46;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .cd-btn-secondary:hover{background:#d1fae5;border-color:#10b981}
  .cd-row:hover td{background:#f0fdf4 !important;transition:background 0.15s}
  .action-btn{width:34px;height:34px;border:none;border-radius:9px;cursor:pointer;font-size:15px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 14px rgba(0,0,0,0.15)}
  .skeleton{background:linear-gradient(90deg,#f0fdf4 25%,#dcfce7 50%,#f0fdf4 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}
  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(16,185,129,0.15);color:#34d399;border-left:3px solid #34d399;padding-left:13px}
  .cd-label{font-size:11px;font-weight:700;color:#065f46;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px;display:block}
  .badge{padding:4px 10px;border-radius:20px;font-size:11px;font-weight:700;display:inline-block}
  .expiry-valid{background:#dcfce7;color:#166534;border:1px solid #86efac}
  .expiry-warn{background:#fef9c3;color:#854d0e;border:1px solid #fde047;animation:blink 1s infinite}
  .expiry-expired{background:#fef2f2;color:#991b1b;border:1px solid #fca5a5;animation:blink-fast 0.6s infinite}
  .expiry-na{background:#f1f5f9;color:#64748b;border:1px solid #cbd5e1}
  .upload-zone{border:2px dashed #bbf7d0;border-radius:12px;padding:16px;text-align:center;
    cursor:pointer;transition:all 0.2s;background:#f0fdf4;position:relative}
  .upload-zone:hover{border-color:#10b981;background:#dcfce7}
  .upload-zone.has-file{border-color:#10b981;background:#dcfce7;border-style:solid}
  .upload-zone input{position:absolute;inset:0;opacity:0;cursor:pointer}
  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#bbf7d0;border-radius:3px}
  .sec-div{display:flex;align-items:center;gap:12px;margin:22px 0 14px}
  .sec-div span{font-size:11px;font-weight:700;color:#059669;text-transform:uppercase;letter-spacing:0.6px;white-space:nowrap}
  .sec-div::before,.sec-div::after{content:'';flex:1;height:1px;background:#d1fae5}
  .search-box{padding:9px 14px 9px 38px;border:1.5px solid #bbf7d0;border-radius:20px;
    background:#fff;font-size:13px;outline:none;width:220px;
    transition:border-color 0.2s,width 0.3s;color:#1a1d2e;font-family:'DM Sans',sans-serif}
  .search-box:focus{border-color:#10b981;box-shadow:0 0 0 3px rgba(16,185,129,0.12);width:280px}
  .tab-btn{padding:8px 18px;border-radius:20px;border:1.5px solid #bbf7d0;background:#f0fdf4;
    color:#065f46;font-size:13px;font-weight:600;cursor:pointer;font-family:'DM Sans',sans-serif;
    transition:all 0.18s}
  .tab-btn.on{background:#10b981;border-color:#10b981;color:#fff;box-shadow:0 4px 12px rgba(16,185,129,0.3)}
`;

// const NAV = [
//   {icon:'⬡', label:'Dashboard',        path:'/dashboard'},
//   {icon:'👥', label:'User Management',  path:'/user-management'},
//   {icon:'⏱️', label:'Rent Durations',   path:'/rent-durations'},
//   {icon:'💰', label:'Car Price',        path:'/car-price'},
//   {icon:'🚕', label:'Transfer Price',   path:'/transfer-price'},
//   {icon:'📅', label:'Weekend Rate',     path:'/weekend-rate'},
//   {icon:'🚖', label:'Cab Details',      path:'/cab-details'},
//   {icon:'📋', label:'Bookings',         path:'/bookings'},
// ];

const FILE_FIELDS = [
  {key:'cab_front_image',    label:'Front Photo',       icon:'📸', accept:'image/*'},
  {key:'cab_back_image',     label:'Back Photo',        icon:'📸', accept:'image/*'},
  {key:'insurance_image',    label:'Insurance Doc',     icon:'📄', accept:'image/*,.pdf'},
  {key:'registration_image', label:'Registration (RC)', icon:'📄', accept:'image/*,.pdf'},
  {key:'permit_image',       label:'Permit Doc',        icon:'📄', accept:'image/*,.pdf'},
  {key:'fitness_image',      label:'Fitness Doc',       icon:'📄', accept:'image/*,.pdf'},
  {key:'pollution_image',    label:'Pollution Doc',     icon:'📄', accept:'image/*,.pdf'},
  {key:'tax_image',          label:'Tax Doc',           icon:'📄', accept:'image/*,.pdf'},
];

const EXPIRY_FIELDS = [
  {key:'insurance', label:'Insurance'},
  {key:'tax',       label:'Tax'},
  {key:'permit',    label:'Permit'},
  {key:'fitness',   label:'Fitness'},
  {key:'pollution', label:'Pollution'},
];

const EMPTY_FORM = {
  cab_group_id:'', brand_id:'', model_id:'', reg_no:'',
  owner_id:'', default_driver_id:'', cab_year:'', color:'',
  insurance_expiry:'', tax_expiry:'', permit_expiry:'',
  fitness_expiry:'', pollution_expiry:'',
  insurance_warning_days:'30', tax_warning_days:'30',
  permit_warning_days:'30', fitness_warning_days:'30', pollution_warning_days:'30',
};

// Expiry badge helper
const expiryBadge = (dateStr, warnDays) => {
  if (!dateStr) return {cls:'expiry-na', label:'N/A'};
  const today = new Date(); today.setHours(0,0,0,0);
  const exp   = new Date(dateStr);
  const days  = Math.round((exp - today) / (1000*60*60*24));
  if (days < 0)       return {cls:'expiry-expired', label:`Expired ${Math.abs(days)}d ago`};
  if (days <= parseInt(warnDays||30)) return {cls:'expiry-warn', label:`⚠ ${days}d left`};
  return {cls:'expiry-valid', label:'Valid'};
};

export default function CabDetails() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,  setAuthUser]  = useState(null);
  const [sideOpen,  setSideOpen]  = useState(true);

  // Meta
  const [groups,    setGroups]    = useState([]);
  const [brands,    setBrands]    = useState([]);
  const [models,    setModels]    = useState([]);
  const [owners,    setOwners]    = useState([]);
  const [drivers,   setDrivers]   = useState([]);

  // Data
  const [cabs,      setCabs]      = useState([]);
  const [loading,   setLoading]   = useState(true);

  // Form
  const [form,      setForm]      = useState(EMPTY_FORM);
  const [files,     setFiles]     = useState({});
  const [previews,  setPreviews]  = useState({});
  const [editId,    setEditId]    = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [activeTab, setActiveTab] = useState('basic');

  // Modals
  const [viewModal, setViewModal] = useState(null);
  const [delModal,  setDelModal]  = useState(null);
  const [delSaving, setDelSaving] = useState(false);

  // Filters
  const [search,    setSearch]    = useState('');
  const [page,      setPage]      = useState(1);
  const [toast,     setToast]     = useState(null);
  const PER = 8;

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
    fetchMeta();
    fetchCabs();
  }, []);

  const fetchMeta = async () => {
    try {
      const r = await API.get('/cab-details/meta');
      setGroups(r.data.groups  || []);
      setBrands(r.data.brands  || []);
      setOwners(r.data.owners  || []);
      setDrivers(r.data.drivers|| []);
    } catch(e) { console.error(e); }
  };

  const fetchCabs = async () => {
    setLoading(true);
    try {
      const r = await API.get('/cab-details');
      setCabs(r.data);
    } catch(e) { showToast('Failed to load cab details', 'error'); }
    setLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg, type});
    setTimeout(() => setToast(null), 3500);
  };

  const resetForm = useCallback(() => {
    setForm(EMPTY_FORM);
    setFiles({});
    setPreviews({});
    setEditId(null);
    setActiveTab('basic');
    setModels([]);
  }, []);

  const startEdit = async (cab) => {
    if (cab.brand_id) {
      try {
        const r = await API.get(`/cab-details/models/${cab.brand_id}`);
        setModels(r.data);
      } catch(e) {}
    }
    setForm({
      cab_group_id:       String(cab.cab_group_id || ''),
      brand_id:           String(cab.brand_id || ''),
      model_id:           String(cab.model_id || ''),
      reg_no:             cab.reg_no || '',
      owner_id:           String(cab.owner_id || ''),
      default_driver_id:  String(cab.default_driver_id || ''),
      cab_year:           cab.cab_year || '',
      color:              cab.color || '',
      insurance_expiry:   cab.insurance_expiry?.split('T')[0] || '',
      tax_expiry:         cab.tax_expiry?.split('T')[0] || '',
      permit_expiry:      cab.permit_expiry?.split('T')[0] || '',
      fitness_expiry:     cab.fitness_expiry?.split('T')[0] || '',
      pollution_expiry:   cab.pollution_expiry?.split('T')[0] || '',
      insurance_warning_days: String(cab.insurance_warning_days || 30),
      tax_warning_days:       String(cab.tax_warning_days || 30),
      permit_warning_days:    String(cab.permit_warning_days || 30),
      fitness_warning_days:   String(cab.fitness_warning_days || 30),
      pollution_warning_days: String(cab.pollution_warning_days || 30),
    });
    // Show existing images as previews
    const prevs = {};
    FILE_FIELDS.forEach(ff => {
      if (cab[ff.key]) prevs[ff.key] = `/${cab[ff.key]}`;
    });
    setPreviews(prevs);
    setFiles({});
    setEditId(cab.cab_id);
    setActiveTab('basic');
    window.scrollTo({top:0, behavior:'smooth'});
  };

  const handleBrandChange = async (brandId) => {
    setForm(p => ({...p, brand_id:brandId, model_id:''}));
    if (!brandId) { setModels([]); return; }
    try {
      const r = await API.get(`/cab-details/models/${brandId}`);
      setModels(r.data);
    } catch(e) {}
  };

  const handleFileChange = (fieldName, file) => {
    if (!file) return;
    setFiles(p => ({...p, [fieldName]: file}));
    const reader = new FileReader();
    reader.onload = (e) => setPreviews(p => ({...p, [fieldName]: e.target.result}));
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    if (!form.cab_group_id || !form.reg_no) {
      showToast('Car Group and Registration Number are required', 'error'); return;
    }
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v]) => fd.append(k, v));
      Object.entries(files).forEach(([k,v]) => fd.append(k, v));

      if (editId) {
        await API.put(`/cab-details/${editId}`, fd, {
          headers: {'Content-Type':'multipart/form-data'}
        });
        showToast('Cab updated successfully ✓');
      } else {
        await API.post('/cab-details', fd, {
          headers: {'Content-Type':'multipart/form-data'}
        });
        showToast('Cab added successfully ✓');
      }
      await fetchCabs();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Operation failed', 'error');
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    setDelSaving(true);
    try {
      await API.delete(`/cab-details/${delModal.cab_id}`);
      showToast('Cab deleted successfully ✓');
      setDelModal(null);
      if (editId === delModal.cab_id) resetForm();
      await fetchCabs();
    } catch(e) {
      showToast(e.response?.data?.message || 'Delete failed', 'error');
    }
    setDelSaving(false);
  };

  const fmtDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('en-IN', {day:'2-digit',month:'short',year:'numeric'});
  };

  const filtered = cabs.filter(c => {
    const q = search.toLowerCase();
    return !search ||
      c.reg_no?.toLowerCase().includes(q) ||
      c.car_name?.toLowerCase().includes(q) ||
      c.group_name?.toLowerCase().includes(q) ||
      c.driver_name?.toLowerCase().includes(q) ||
      c.owner_name?.toLowerCase().includes(q);
  });
  const totalPages = Math.ceil(filtered.length / PER);
  const paged      = filtered.slice((page-1)*PER, page*PER);
  const logout     = () => { localStorage.clear(); navigate('/login'); };
  const f          = (k) => (e) => setForm(p => ({...p, [k]: e.target.value}));

  // Count expiry warnings
  const warnCount = cabs.reduce((acc, c) => {
    EXPIRY_FIELDS.forEach(ef => {
      const b = expiryBadge(c[`${ef.key}_expiry`], c[`${ef.key}_warning_days`]);
      if (b.cls !== 'expiry-valid' && b.cls !== 'expiry-na') acc++;
    });
    return acc;
  }, 0);

  const UploadField = ({ fieldKey, label, icon, accept }) => {
    const inputRef = useRef();
    const hasFile  = previews[fieldKey];
    const isPdf    = hasFile?.includes('pdf') || files[fieldKey]?.name?.endsWith('.pdf');
    return (
      <div>
        <label className="cd-label">{icon} {label}</label>
        <div className={`upload-zone${hasFile?' has-file':''}`}
          onClick={() => inputRef.current?.click()}>
          <input ref={inputRef} type="file" accept={accept}
            onChange={e => handleFileChange(fieldKey, e.target.files[0])}/>
          {hasFile ? (
            isPdf ? (
              <div style={{display:'flex',alignItems:'center',gap:8,justifyContent:'center'}}>
                <span style={{fontSize:28}}>📄</span>
                <div>
                  <div style={{fontSize:12,fontWeight:700,color:'#065f46'}}>PDF Uploaded</div>
                  <div style={{fontSize:10,color:'#10b981'}}>Click to replace</div>
                </div>
              </div>
            ) : (
              <div>
                <img src={hasFile} alt={label}
                  style={{height:70,maxWidth:'100%',borderRadius:8,objectFit:'cover'}}/>
                <div style={{fontSize:10,color:'#10b981',marginTop:4}}>Click to replace</div>
              </div>
            )
          ) : (
            <div>
              <div style={{fontSize:28,marginBottom:4}}>☁️</div>
              <div style={{fontSize:12,color:'#6b7280'}}>Click to upload</div>
              <div style={{fontSize:10,color:'#a0aec0',marginTop:2}}>JPG, PNG, PDF · max 2MB</div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <Layout activePage="Cab Owner Details">
    <>
      <style>{STYLES}</style>
      <ToastContainer position="top-right" autoClose={3000} />

        {/* ── Sidebar ── */}
        {/* <aside style={{...S.sidebar, width: sideOpen?220:68}}>
          <div style={S.sideTop}>
            <div style={S.logoWrap}>
              <div style={S.logoIcon}>🚗</div>
              {sideOpen && <span style={S.logoText}>Orisys</span>}
            </div>
            <button style={S.collapseBtn} onClick={()=>setSideOpen(p=>!p)}>
              {sideOpen?'◀':'▶'}
            </button>
          </div>
          <nav style={{flex:1}}>
            {NAV.map(n=>(
              <div key={n.label}
                className={`nav-item${location.pathname===n.path?' active':''}`}
                onClick={()=>navigate(n.path)}>
                <span style={{fontSize:16,flexShrink:0}}>{n.icon}</span>
                {sideOpen && <span style={{fontWeight:500}}>{n.label}</span>}
              </div>
            ))}
          </nav>
          <div style={S.sideBottom}>
            {sideOpen && (
              <div style={S.userChip}>
                <div style={S.avatar}>{authUser?.user_name?.[0]||'A'}</div>
                <div>
                  <div style={S.uname}>{authUser?.user_name||'Admin'}</div>
                  <div style={S.urole}>Administrator</div>
                </div>
              </div>
            )}
            <button style={S.logoutBtn} onClick={logout}>
              <span>🚪</span>{sideOpen&&<span style={{marginLeft:8}}>Logout</span>}
            </button>
          </div>
        </aside> */}

        {/* ── Main ── */}
        

          {/* Header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Cab Details</h1>
              <p style={S.pageSub}>Fleet management — vehicle documents & expiry tracking</p>
            </div>
            <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
              {[
                {label:'Total Cabs',    value:cabs.length,  color:'#059669',bg:'#f0fdf4',icon:'🚖'},
                {label:'Alerts',        value:warnCount,    color:'#dc2626',bg:'#fef2f2',icon:'⚠️'},
              ].map(s=>(
                <div key={s.label} style={{...S.miniStat,background:s.bg}}>
                  <span style={{fontSize:22}}>{s.icon}</span>
                  <div>
                    <div style={{fontSize:22,fontWeight:800,color:s.color,lineHeight:1}}>{s.value}</div>
                    <div style={{fontSize:10,color:'#718096',fontWeight:600,textTransform:'uppercase'}}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Add / Edit Form ── */}
          <div style={S.formCard}>
            <div style={S.formCardHead}>
              <div style={S.formCardIcon}>{editId?'✏️':'🚖'}</div>
              <div style={{flex:1}}>
                <h2 style={S.formCardTitle}>{editId?'Edit Cab Details':'Add New Cab'}</h2>
                <p style={S.formCardSub}>
                  {editId
                    ? `Editing: ${cabs.find(c=>c.cab_id===editId)?.reg_no}`
                    : 'Register a new cab with vehicle info, documents & expiry dates'}
                </p>
              </div>
              {editId && (
                <button className="cd-btn-secondary" onClick={resetForm}>✕ Cancel</button>
              )}
            </div>

            {/* Tabs */}
            <div style={{display:'flex',gap:8,marginBottom:20,flexWrap:'wrap'}}>
              {[
                {id:'basic',   label:'🚗 Basic Info'},
                {id:'expiry',  label:'📅 Expiry & Warning'},
                {id:'docs',    label:'📁 Documents & Photos'},
              ].map(t=>(
                <button key={t.id} className={`tab-btn${activeTab===t.id?' on':''}`}
                  onClick={()=>setActiveTab(t.id)}>
                  {t.label}
                </button>
              ))}
            </div>

            {/* ── Tab: Basic Info ── */}
            {activeTab==='basic' && (
              <div>
                <div style={S.formGrid2}>
                  <div>
                    <label className="cd-label">Car Group *</label>
                    <select className="cd-select" value={form.cab_group_id} onChange={f('cab_group_id')}>
                      <option value="">— Select Group —</option>
                      {groups.map(g=>(
                        <option key={g.group_id} value={g.group_id}>{g.group_name}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="cd-label">Registration No *</label>
                    <input className="cd-input" placeholder="e.g. MH12AB1234"
                      value={form.reg_no}
                      onChange={e=>setForm(p=>({...p,reg_no:e.target.value.toUpperCase()}))}
                      style={{fontFamily:'monospace',fontWeight:700,letterSpacing:'2px'}}/>
                  </div>
                  <div>
                    <label className="cd-label">Brand</label>
                    <select className="cd-select" value={form.brand_id}
                      onChange={e=>handleBrandChange(e.target.value)}>
                      <option value="">— Select Brand —</option>
                      {brands.map(b=>(
                        <option key={b.brand_id} value={b.brand_id}>{b.brand_name}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="cd-label">Model</label>
                    <select className="cd-select" value={form.model_id} onChange={f('model_id')}
                      disabled={!form.brand_id||models.length===0}>
                      <option value="">— Select Model —</option>
                      {models.map(m=>(
                        <option key={m.model_id} value={m.model_id}>{m.model_name}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="cd-label">Owner</label>
                    <select className="cd-select" value={form.owner_id} onChange={f('owner_id')}>
                      <option value="">— Select Owner —</option>
                      {owners.map(o=>(
                        <option key={o.owner_id} value={o.owner_id}>{o.owner_name}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="cd-label">Default Driver</label>
                    <select className="cd-select" value={form.default_driver_id} onChange={f('default_driver_id')}>
                      <option value="">— Select Driver —</option>
                      {drivers.map(d=>(
                        <option key={d.driver_id} value={d.driver_id}>{d.driver_name}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="cd-label">Year of Manufacture</label>
                    <input className="cd-input" type="number" min="2000" max={new Date().getFullYear()}
                      placeholder="e.g. 2022" value={form.cab_year} onChange={f('cab_year')}/>
                  </div>
                  <div>
                    <label className="cd-label">Color</label>
                    <input className="cd-input" placeholder="e.g. White"
                      value={form.color} onChange={f('color')}/>
                  </div>
                </div>
                <div style={{display:'flex',justifyContent:'flex-end',marginTop:16}}>
                  <button className="cd-btn-primary"
                    onClick={()=>setActiveTab('expiry')} style={{animation:'none'}}>
                    Next: Expiry Dates →
                  </button>
                </div>
              </div>
            )}

            {/* ── Tab: Expiry & Warning ── */}
            {activeTab==='expiry' && (
              <div>
                {EXPIRY_FIELDS.map(ef=>(
                  <div key={ef.key} style={{...S.expiryRow,
                    background: form[`${ef.key}_expiry`]
                      ? expiryBadge(form[`${ef.key}_expiry`], form[`${ef.key}_warning_days`]).cls === 'expiry-expired'
                        ? '#fef2f2' : expiryBadge(form[`${ef.key}_expiry`], form[`${ef.key}_warning_days`]).cls === 'expiry-warn'
                        ? '#fefce8' : '#f0fdf4'
                      : '#f9fafb'
                  }}>
                    <div style={{flex:1}}>
                      <label className="cd-label">{ef.label} Expiry Date</label>
                      <input className="cd-input" type="date"
                        value={form[`${ef.key}_expiry`]}
                        onChange={f(`${ef.key}_expiry`)}/>
                    </div>
                    <div style={{width:130}}>
                      <label className="cd-label">Warn Before (days)</label>
                      <input className="cd-input" type="number" min="1" max="365"
                        value={form[`${ef.key}_warning_days`]}
                        onChange={f(`${ef.key}_warning_days`)}/>
                    </div>
                    <div style={{width:120,display:'flex',alignItems:'flex-end',paddingBottom:2}}>
                      {form[`${ef.key}_expiry`] ? (
                        <span className={`badge ${expiryBadge(form[`${ef.key}_expiry`],form[`${ef.key}_warning_days`]).cls}`}
                          style={{fontSize:11}}>
                          {expiryBadge(form[`${ef.key}_expiry`],form[`${ef.key}_warning_days`]).label}
                        </span>
                      ) : (
                        <span style={{fontSize:12,color:'#a0aec0'}}>Not set</span>
                      )}
                    </div>
                  </div>
                ))}
                <div style={{display:'flex',justifyContent:'space-between',marginTop:16}}>
                  <button className="cd-btn-secondary" onClick={()=>setActiveTab('basic')}>← Back</button>
                  <button className="cd-btn-primary" onClick={()=>setActiveTab('docs')}
                    style={{animation:'none'}}>Next: Documents →</button>
                </div>
              </div>
            )}

            {/* ── Tab: Documents & Photos ── */}
            {activeTab==='docs' && (
              <div>
                <div style={S.formGrid4}>
                  {FILE_FIELDS.map(ff=>(
                    <UploadField key={ff.key} fieldKey={ff.key}
                      label={ff.label} icon={ff.icon} accept={ff.accept}/>
                  ))}
                </div>
                <div style={{display:'flex',justifyContent:'space-between',marginTop:20}}>
                  <button className="cd-btn-secondary" onClick={()=>setActiveTab('expiry')}>← Back</button>
                  <button className="cd-btn-primary" onClick={handleSubmit} disabled={saving}>
                    {saving
                      ? <span style={S.spinner}/>
                      : editId ? '💾 Update Cab' : '＋ Add Cab'}
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* ── Manage Table ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>📋 Manage Cabs</h3>
              <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:12,top:'50%',
                    transform:'translateY(-50%)',color:'#a0aec0',fontSize:14,pointerEvents:'none'}}>🔍</span>
                  <input className="search-box" placeholder="Search reg, car, driver…"
                    value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/>
                </div>
                <span style={{fontSize:12,background:'#f0fdf4',color:'#059669',
                  borderRadius:20,padding:'4px 14px',fontWeight:700,whiteSpace:'nowrap'}}>
                  {filtered.length} cabs
                </span>
              </div>
            </div>

            <div style={{overflowX:'auto'}}>
              <table style={S.table}>
                <thead>
                  <tr style={{background:'linear-gradient(135deg,#f0fdf4,#dcfce7)'}}>
                    {['#','Cab Info','Reg No','Owner','Driver',
                      'Insurance','Permit','Fitness','Pollution','Photo','Actions'].map(h=>(
                      <th key={h} style={S.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? Array.from({length:5}).map((_,i)=>(
                        <tr key={i}>{Array.from({length:11}).map((_,j)=>(
                          <td key={j} style={S.td}><div className="skeleton" style={{height:14,width:'80%'}}/></td>
                        ))}</tr>
                      ))
                    : paged.length===0
                    ? (
                        <tr>
                          <td colSpan={11} style={{textAlign:'center',padding:'48px 0',color:'#a0aec0'}}>
                            <div style={{fontSize:40,marginBottom:10}}>🚖</div>
                            <div style={{fontSize:15,fontWeight:600}}>No cabs registered yet</div>
                            <div style={{fontSize:13,marginTop:4}}>Use the form above to add your first cab</div>
                          </td>
                        </tr>
                      )
                    : paged.map((c,i)=>(
                        <tr key={c.cab_id} className="cd-row"
                          style={{borderBottom:'1px solid #f0fdf4',
                            background:editId===c.cab_id?'#f0fdf4':i%2===0?'#fff':'#f9fffb'}}>
                          <td style={{...S.td,color:'#a0aec0',fontWeight:700,fontSize:12}}>
                            {(page-1)*PER+i+1}
                          </td>
                          <td style={S.td}>
                            <div style={{display:'flex',alignItems:'center',gap:10}}>
                              <div style={{width:36,height:36,borderRadius:10,flexShrink:0,
                                background:'linear-gradient(135deg,#34d399,#10b981)',
                                display:'flex',alignItems:'center',justifyContent:'center',fontSize:18}}>
                                🚖
                              </div>
                              <div>
                                <div style={{fontWeight:700,fontSize:13,color:'#1a1d2e'}}>
                                  {c.brand_name} {c.model_name || ''}
                                </div>
                                <div style={{fontSize:11,color:'#a0aec0'}}>
                                  {c.group_name} · {c.cab_year||'—'}
                                </div>
                                {editId===c.cab_id&&(
                                  <span style={{fontSize:10,background:'#fef9c3',color:'#854d0e',
                                    padding:'1px 6px',borderRadius:10,fontWeight:700}}>EDITING</span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td style={S.td}>
                            <span style={{fontFamily:'monospace',fontWeight:800,fontSize:13,
                              background:'#f0fdf4',color:'#065f46',padding:'3px 8px',borderRadius:6,
                              border:'1px solid #bbf7d0'}}>
                              {c.reg_no}
                            </span>
                          </td>
                          <td style={{...S.td,fontSize:12}}>{c.owner_name||'—'}</td>
                          <td style={{...S.td,fontSize:12}}>{c.driver_name||'—'}</td>
                          {['insurance','permit','fitness','pollution'].map(ef=>{
                            const b = expiryBadge(c[`${ef}_expiry`], c[`${ef}_warning_days`]);
                            return (
                              <td key={ef} style={S.td}>
                                <span className={`badge ${b.cls}`} style={{fontSize:10,whiteSpace:'nowrap'}}>
                                  {b.label}
                                </span>
                              </td>
                            );
                          })}
                          <td style={S.td}>
                            {c.cab_front_image ? (
                              <img src={`${API_BASE}/${c.cab_front_image}`} alt="cab"
                                style={{width:50,height:36,objectFit:'cover',borderRadius:6,
                                  border:'1px solid #bbf7d0',cursor:'pointer'}}
                                onClick={()=>setViewModal(c)}/>
                            ) : (
                              <span style={{color:'#a0aec0',fontSize:11}}>No photo</span>
                            )}
                          </td>
                          <td style={S.td}>
                            <div style={{display:'flex',gap:6}}>
                              <button className="action-btn" style={{background:'#dcfce7',color:'#166534'}}
                                title="View" onClick={()=>setViewModal(c)}>👁</button>
                              <button className="action-btn" style={{background:'#fefcbf',color:'#744210'}}
                                title="Edit" onClick={()=>startEdit(c)}>✏️</button>
                              <button className="action-btn" style={{background:'#fff5f5',color:'#c53030'}}
                                title="Delete" onClick={()=>setDelModal(c)}>🗑</button>
                            </div>
                          </td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            </div>

            {totalPages>1 && (
              <div style={S.pagination}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER+1}–{Math.min(page*PER,filtered.length)} of {filtered.length}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1).map(p=>(
                    <button key={p} style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                      onClick={()=>setPage(p)}>{p}</button>
                  ))}
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>
       

        {/* ── View Modal ── */}
        {viewModal && (
          <div style={S.overlay} onClick={()=>setViewModal(null)}>
            <div style={{...S.modal,maxWidth:680}} onClick={e=>e.stopPropagation()}>
              <div style={S.modalHead}>
                <div>
                  <h2 style={S.modalTitle}>🚖 Cab Details</h2>
                  <p style={S.modalSub}>{viewModal.reg_no} · {viewModal.brand_name} {viewModal.model_name}</p>
                </div>
                <button style={S.xBtn} onClick={()=>setViewModal(null)}>✕</button>
              </div>
              <div className="modal-scroll" style={{padding:'20px 28px'}}>
                {/* Hero image row */}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:20}}>
                  {['cab_front_image','cab_back_image'].map(f=>(
                    <div key={f} style={{borderRadius:12,overflow:'hidden',
                      border:'1.5px solid #bbf7d0',background:'#f0fdf4',
                      height:140,display:'flex',alignItems:'center',justifyContent:'center'}}>
                      {viewModal[f]
                        ? <img src={`${API_BASE}/${viewModal[f]}`} alt={f}
                            style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                        : <span style={{fontSize:30,opacity:0.3}}>🚖</span>
                      }
                    </div>
                  ))}
                </div>

                {/* Info grid */}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:20}}>
                  {[
                    {label:'Registration',value:viewModal.reg_no,mono:true},
                    {label:'Car Group',   value:viewModal.group_name},
                    {label:'Brand',       value:viewModal.brand_name||'—'},
                    {label:'Model',       value:viewModal.model_name||'—'},
                    {label:'Year',        value:viewModal.cab_year||'—'},
                    {label:'Color',       value:viewModal.color||'—'},
                    {label:'Owner',       value:viewModal.owner_name||'—'},
                    {label:'Driver',      value:viewModal.driver_name||'—'},
                  ].map(r=>(
                    <div key={r.label} style={{background:'#f0fdf4',borderRadius:10,
                      padding:'10px 14px',border:'1px solid #bbf7d0'}}>
                      <div style={{fontSize:10,color:'#059669',fontWeight:700,
                        textTransform:'uppercase',letterSpacing:'0.4px'}}>{r.label}</div>
                      <div style={{fontSize:14,fontWeight:700,color:'#1a1d2e',marginTop:3,
                        fontFamily:r.mono?'monospace':'inherit'}}>{r.value}</div>
                    </div>
                  ))}
                </div>

                {/* Expiry status */}
                <div className="sec-div"><span>Document Expiry Status</span></div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:8,marginBottom:20}}>
                  {EXPIRY_FIELDS.map(ef=>{
                    const b = expiryBadge(viewModal[`${ef.key}_expiry`], viewModal[`${ef.key}_warning_days`]);
                    return (
                      <div key={ef.key} style={{textAlign:'center',padding:'12px 8px',
                        borderRadius:10,border:'1.5px solid #e5e7eb',
                        background:b.cls==='expiry-valid'?'#f0fdf4':b.cls==='expiry-expired'?'#fef2f2':'#fefce8'}}>
                        <div style={{fontSize:10,color:'#718096',fontWeight:600,
                          textTransform:'uppercase',marginBottom:4}}>{ef.label}</div>
                        <span className={`badge ${b.cls}`} style={{fontSize:10}}>{b.label}</span>
                        <div style={{fontSize:10,color:'#a0aec0',marginTop:4}}>
                          {fmtDate(viewModal[`${ef.key}_expiry`])}
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Document thumbs */}
                <div className="sec-div"><span>Documents</span></div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10}}>
                  {FILE_FIELDS.filter(ff=>!['cab_front_image','cab_back_image'].includes(ff.key)).map(ff=>(
                    <div key={ff.key} style={{borderRadius:10,overflow:'hidden',
                      border:'1.5px solid #bbf7d0',background:'#f0fdf4',
                      height:90,display:'flex',alignItems:'center',justifyContent:'center',
                      flexDirection:'column',gap:4}}>
                      {viewModal[ff.key]
                        ? viewModal[ff.key].endsWith('.pdf')
                          ? <><span style={{fontSize:28}}>📄</span><span style={{fontSize:10,color:'#059669'}}>PDF</span></>
                          : <img src={`${API_BASE}/${viewModal[ff.key]}`} alt={ff.label}
                              style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                        : <><span style={{fontSize:22,opacity:0.3}}>📄</span>
                            <span style={{fontSize:10,color:'#a0aec0'}}>{ff.label}</span></>
                      }
                    </div>
                  ))}
                </div>
              </div>
              <div style={S.modalFoot}>
                <button className="cd-btn-secondary" onClick={()=>setViewModal(null)}>Close</button>
                <button className="cd-btn-primary" style={{animation:'none'}}
                  onClick={()=>{setViewModal(null);setTimeout(()=>startEdit(viewModal),100);}}>
                  ✏️ Edit Cab
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Delete Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>Delete Cab?</h2>
                <div style={{marginBottom:16,display:'flex',gap:8,justifyContent:'center',flexWrap:'wrap'}}>
                  <span className="badge" style={{background:'#f0fdf4',color:'#065f46',
                    fontFamily:'monospace',fontSize:13}}>
                    {delModal.reg_no}
                  </span>
                  <span className="badge" style={{background:'#f0fdf4',color:'#059669'}}>
                    {delModal.brand_name} {delModal.model_name}
                  </span>
                </div>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  All associated documents and images will be permanently deleted.<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="cd-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} onClick={handleDelete} style={{
                    padding:'12px 24px',background:'linear-gradient(135deg,#fc8181,#e53e3e)',
                    border:'none',borderRadius:11,color:'#fff',fontWeight:700,fontSize:14,
                    fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                    display:'flex',alignItems:'center',gap:8}}>
                    {delSaving?<span style={S.spinner}/>:'🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#f0fdf4',
            borderColor:toast.type==='error'?'#fc8181':'#34d399',
            color:toast.type==='error'?'#c53030':'#065f46'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      {/* </div> */}
    </>
    </Layout>
  );
}

const S = {
//   root:{display:'flex',minHeight:'100vh',background:'#f7fdf9'},
  
  main:{flex:1,padding:'28px',minWidth:0},
  pageHeader:{display:'flex',width:'98%',justifyContent:'space-between',alignItems:'flex-start',
    marginBottom:24,flexWrap:'wrap',gap:16},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,
    fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  miniStat:{display:'flex',alignItems:'center',gap:12,borderRadius:14,padding:'14px 18px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.05)'},

  formCard:{background:'#fff',width:'98%',borderRadius:20,padding:'28px',
    boxShadow:'0 4px 24px rgba(16,185,129,0.08)',marginBottom:24,border:'1.5px solid #bbf7d0'},
  formCardHead:{display:'flex',alignItems:'flex-start',gap:16,marginBottom:20},
  formCardIcon:{width:48,height:48,background:'linear-gradient(135deg,#34d399,#10b981)',
    borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',
    fontSize:22,flexShrink:0,boxShadow:'0 4px 14px rgba(16,185,129,0.3)'},
  formCardTitle:{fontSize:18,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  formCardSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  formGrid2:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16},
  formGrid4:{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:14},
  expiryRow:{display:'grid',gridTemplateColumns:'1fr 130px 120px',gap:16,
    alignItems:'end',padding:'14px',borderRadius:12,marginBottom:10,
    border:'1px solid #e5e7eb',transition:'background 0.2s'},

  tableCard:{background:'#fff',width:'98%',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(16,185,129,0.08)',marginBottom:20,border:'1.5px solid #bbf7d0'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #f0fdf4',flexWrap:'wrap',gap:12},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'13px 14px',fontSize:11,fontWeight:700,color:'#059669',textAlign:'left',
    textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'2px solid #dcfce7'},
  td:{padding:'12px 14px',fontSize:13,color:'#4a5568',verticalAlign:'middle'},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'16px 24px',borderTop:'1px solid #f0fdf4'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #bbf7d0',borderRadius:8,background:'#fff',
    color:'#059669',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#10b981',borderColor:'#10b981',color:'#fff'},

  overlay:{position:'fixed',inset:0,background:'rgba(5,15,10,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,maxHeight:'90vh',
    display:'flex',flexDirection:'column',
    boxShadow:'0 32px 80px rgba(16,185,129,0.2)',animation:'modalIn 0.3s ease both'},
  modalHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    padding:'24px 28px 0',flexShrink:0},
  modalTitle:{fontSize:20,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  modalSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  modalFoot:{display:'flex',gap:12,justifyContent:'flex-end',
    padding:'16px 28px',borderTop:'1px solid #f0fdf4',flexShrink:0},
  xBtn:{background:'rgba(52,211,153,0.15)',border:'none',color:'#059669',borderRadius:'50%',
    width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,
    display:'flex',alignItems:'center',justifyContent:'center'},
  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.12)',
    animation:'fadeSlideIn 0.3s ease'},
};